// extracted by mini-css-extract-plugin
module.exports = {"elements":"s3AqgudacShKv1DiiHS5"};